import classNames from "classnames";
import React, { Component } from "react";
import "../../../../styles/main.scss";

interface KuikaCodeTextProps extends React.HTMLAttributes<HTMLSpanElement> {
  children: React.ReactNode;
}

class KuikaCodeText extends Component<KuikaCodeTextProps> {
  render() {
    const { children, className, ...props } = this.props;

    return (
      <span className={classNames("kuika-typography-code", className)} {...props}>
        {children}
      </span>
    );
  }
}

export default KuikaCodeText;
